<template>
  <a-modal
    title="修改密码"
    :visible="visible"
    :confirm-loading="loading"
    :mask-closable="false"
    wrap-class-name="change-pwd-modal"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form :form="form" layout="vertical" @submit.prevent="handleSubmit">
      <a-form-item label="原密码">
        <a-input-password
          v-decorator="[
            'oldpassword',
            { rules: [{ required: true, message: '请输入原密码' }] }
          ]"
          placeholder="请输入原密码"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="新密码">
        <a-input-password
          v-decorator="[
            'newpassword',
            { rules: [
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码至少 6 位' }
            ] }
          ]"
          placeholder="请输入新密码（至少 6 位）"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="确认新密码">
        <a-input-password
          v-decorator="[
            'confirm',
            { rules: [
              { required: true, message: '请再次输入新密码' },
              { validator: validateConfirm }
            ] }
          ]"
          placeholder="请再次输入新密码"
          allow-clear
        />
      </a-form-item>
    </a-form>
    <a-alert
      v-if="false"
      message="修改成功后需重新登录"
      type="info"
      show-icon
    />
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChangePasswordModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('auth', ['changepwd']),
    // 校验两次新密码一致
    validateConfirm(rule, value, callback) {
      const newpassword = this.form.getFieldValue('newpassword')
      if (value && value !== newpassword) {
        callback(new Error('两次输入的新密码不一致'))
      } else {
        callback()
      }
    },
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (err) return
        this.loading = true
        try {
          await this.changepwd({
            oldpassword: values.oldpassword,
            newpassword: values.newpassword
          })
          this.$message.success('密码修改成功，请重新登录')
          this.$emit('success')
          this.resetForm()
        } catch (e) {
          this.$message.error(e.message || '修改失败')
        } finally {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('update:visible', false)
    },
    resetForm() {
      this.form.resetFields()
    }
  }
}
</script>

<!-- 非 scoped：a-modal 默认 portal 到 body，scoped 选不到。
     用 wrapClassName 限定作用域，避免污染全局 input 样式。 -->
<style lang="scss">
.change-pwd-modal {
  /* antd 1.7 的 affix-wrapper 对 .ant-input 有全局 padding:0 重置，需 !important 覆盖 */
  .ant-input-affix-wrapper .ant-input {
    padding: 0 14px !important;
  }
}
</style>
